import Vue from 'vue'
import { Notification } from 'element-ui'

import store from '@/store/'
import Router from 'vue-router'
import Layout from '@/components/Layout/'
import Login from '@/components/Login/'
import Main from '@/components/Main/'
import Projects from '@/components/Projects/'
import Project from '@/components/Project/'
import Create from '@/components/Create/'
import NoPage from '@/components/NoPage/'
import FirebaseCRUD from '@/components/FirestoreCRUD.vue'

Vue.use(Router)

function go(next, name) {
  store.commit('setTitle', name)
  if (next instanceof Function) next()
}

/* Router */
const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      component: Layout,
      children: [{
          path: '/',
          name: 'Main',
          component: Main
        },
        {
          path: '/projects/:uid',
          name: 'MyProject',
          component: Projects,
          meta: { authRequired: true }
        },
        {
          path: '/create',
          name: 'CreateProject',
          component: Create,
          meta: { authRequired: true }
        },
        {
          path: '/projects/:uid/:pid',
          name: 'Project',
          component: Project
        },
        {
          path: '/FirebaseCRUD',
          name: 'FirebaseCRUD',
          component: FirebaseCRUD
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '*',
      name: 'NoPage',
      component: NoPage
    }
  ]
})

router.beforeEach(function(to, from, next) {
  try {
    to.matched.some(function(routeInfo) {
      if (routeInfo.meta.authRequired) {
        if (store.state.isLogin) {
          go(next(), to.name)
        } else {
          var path
          if (from.name === 'Login') {
            path = '/'
          } else {
            path = '/login'
            Notification.warning({
              title: 'Login',
              message: '로그인이 필요해요!',
              position: 'bottom-right'
            })
          }

          go(next({
            path: path,
            query: { redirect: to.fullPath } // Redirect URL after login.
          }), 'Login')
        }
      } else {
        // 로그인 불필요
        go(next(), to.name)
      }
    })
  } catch (e) {
    // 그 외
    // [임시코드]
    go(next(), to.name)
    // [/임시코드]
    // 배포시 사용하는 코드
    // console.warn(e)
    // next({path: '/'})
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js